var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaPeque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    width: 32,
    height: 32,
    fill: "#69bfbe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258.9,507.2C120.4,507.9,6.6,392.6,9.9,252C12.9,118,124,7,262.3,8.7c136.6,1.7,249.4,115.4,245.8,256C504.7,398.2,394.7,507.8,258.9,507.2z M40.2,257.9c0.9,122.6,97.9,218.2,214.4,219.9c123.6,1.8,222.8-95.7,223.1-219.5c0.1-122.7-97.8-218-214.5-220.3C143.1,35.7,41.2,132.3,40.2,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2,261.3c0,21.8-0.6,43.7,0.1,65.5c1.5,41.9-28.7,76.9-68.6,86.9c-7.8,2-16.1,3.2-24.1,3.3c-42.3,0.3-84.6,0.7-126.9,0c-35.3-0.6-63.1-15.6-81.9-46.1c-7.2-11.7-10.8-24.7-10.8-38.5c-0.1-47.5-0.5-95,0.1-142.4c0.4-31,15.9-53.9,41.6-70.3c16-10.2,33.7-14.8,52.6-14.8c41.3-0.1,82.6-0.5,123.9,0.1c36.4,0.5,65.2,15.7,83.9,47.7c6.7,11.5,10.1,24.2,10.1,37.7C413.1,214,413.2,237.7,413.2,261.3z M124,261.1c0,22.8,0,45.7,0,68.5c0,9.1,1.7,17.9,6,26c13.8,26,36.4,37.8,64.9,38.2c41.3,0.6,82.7,0.3,124,0c7.1,0,14.3-1.2,21.2-3c27.5-7.4,50.9-31.2,50.1-66.1c-1-44-0.2-88-0.2-132c0-9.7-1.8-18.9-6.5-27.4c-14.1-25.3-36.6-36.8-64.6-37.2c-41.2-0.6-82.3-0.4-123.5,0c-8.2,0.1-16.6,1.6-24.5,4c-26.9,8.3-48.1,32.2-47,64.4C124.6,218.1,124,239.6,124,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1,183c40.7-0.1,73.7,32.4,73.7,72.4c-0.1,39.8-33,72.3-73.3,72.4c-40.6,0.1-73.5-32.3-73.5-72.5C184,215.4,216.6,183.1,257.1,183z M257.1,206.2c-27.4,0.1-50,22.4-49.9,49.3s22.6,49,50.2,49.1c27.5,0,50.1-22.1,50.2-49C307.5,228.3,284.8,206.1,257.1,206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,176.7c0.2,8.5-6.8,16-15.1,16.3c-8.5,0.3-15.8-6.9-15.9-15.8c-0.1-8.7,6.6-16,14.9-16.3   C347.2,160.6,354.6,167.9,354.8,176.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaPeque);
export default __webpack_public_path__ + "static/media/insta-peque.26d0481b7b9a215cddc8de6d624382cb.svg";
export { ForwardRef as ReactComponent };